import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { EventsHero, EventsStats } from "@/components/events/EventsHero";
import { HowWeHost, Experience, Audience } from "@/components/events/EventsInfo";
import { Calendar } from "@/components/events/Calendar";
import { Register } from "@/components/events/Register";
import { Partner } from "@/components/events/Partner";
import { JoinList, Organisers } from "@/components/events/JoinList";

export default function Events() {
  const [data, setData] = useState(null);
  const [session, setSession] = useState("");
  const [params] = useSearchParams();

  useEffect(() => {
    api.get("/events/origin-cup").then((r) => {
      setData(r.data);
      const first = r.data.sessions.find((s) => s.status === "upcoming" && s.seats_left > 0);
      const wanted = r.data.sessions.find((s) => s.date === params.get("session") && s.status === "upcoming" && s.seats_left > 0);
      setSession((wanted || first)?.date || "");
    });
    if (params.get("booking") === "cancelled") toast("Booking cancelled. Your seat was not charged.");
  }, [params]);

  useEffect(() => {
    if (data && window.location.hash) setTimeout(() => document.querySelector(window.location.hash)?.scrollIntoView(), 150);
  }, [data]);

  const book = (date) => { setSession(date); document.getElementById("register")?.scrollIntoView({ behavior: "smooth" }); };

  if (!data) return <div className="max-w-7xl mx-auto px-5 py-24 overline text-[#575757]" data-testid="events-loading">Loading events…</div>;
  return (
    <div data-testid="events-page">
      <EventsHero next={data.next} />
      <EventsStats />
      <HowWeHost />
      <Experience />
      <Calendar sessions={data.sessions} onBook={book} />
      <Audience />
      <Register data={data} session={session} setSession={setSession} />
      <Partner sessions={data.sessions} />
      <JoinList categories={data.categories} />
      <Organisers />
    </div>
  );
}
